import React from "react";
import paymentStatusEnum from "../../data/paymentStatusEnum";
import useFunction from "../../hooks/useFunction";
import usePrice from "../../hooks/usePrice";
import Button from "../Button/Button";
import PropTypes from "prop-types";
import useInvoiceService from "../../api/services/useInvoiceService";

const PaymentRow = ({payment, showLinksToBooking = false}) => {
  const {formatPrice} = usePrice()
  const {dateTime} = useFunction()
  const {handleStreamInvoicePdf} = useInvoiceService()
  const getPaymentStatusLabel = (value) => {
    return paymentStatusEnum.find(status => status.value === value).label
  }

  return (
    <div className="component-payment-row">
      <div className="fields">

        <div className="field status">
          <p className={"label"}>Status:</p>
          {getPaymentStatusLabel(payment.status)}
          {payment.booking &&
            <>
              {showLinksToBooking
                ? <p><Button size="xs" color="grey-ghost" link={"/user/boeking/" + payment.booking.id} label="Boeking"/>
                </p>
                : <>
                  <p className={"label"}>Boeking ID:</p>
                  <p>{payment.booking.booking_number}</p>
                </>
              }
            </>
          }
        </div>

        {payment.amount &&
          <div className="field amount">
            <p className={"label"}>Bedrag (incl. btw):</p>
            <p>{formatPrice(payment.amount)}</p>
          </div>
        }

        {/*{payment.user &&*/}
        {/*  <div className="field user">*/}
        {/*    <p className={"label"}>Betaald door:</p>*/}
        {/*    <p>{payment.user.first_name}</p>*/}
        {/*    <p>{payment.user.email}</p>*/}
        {/*  </div>*/}
        {/*}*/}

        <div className="field pay">
          {payment.payment_url && payment.status === 'open' &&
            <Button
              label="Betalen via iDeal"
              size="s"
              linkOutside={payment.payment_url}
              target="_blank"
            />
          }
          <Button
            label="Download factuur"
            size="s"
            onClick={() => handleStreamInvoicePdf(payment.invoice_id)}
            debounce={3000}
            target="_blank"
          />
        </div>

        <div className="field meta">
          <p className={"label"}>Aangemaakt:</p>
          <p>{dateTime(payment.created_at)}</p>

          {payment.updated_at !== null && payment.updated_at !== payment.created_at &&
            <>
              <p className={"label"}>Geupdate:</p>
              <p>{dateTime(payment.updated_at)}</p>
            </>
          }
        </div>

      </div>
    </div>
  )
}

PaymentRow.prototype = {
  payment: PropTypes.object.isRequired,
  showLinksToBooking: PropTypes.bool,
}

export default PaymentRow;